import React, { createContext, useState, ReactNode, useCallback } from 'react';

interface ToastContextType {
  showToast: (message: string) => void;
}

// FIX: Export ToastContext so it can be imported and used by the useToast hook in its dedicated file.
export const ToastContext = createContext<ToastContextType | undefined>(undefined);

// The useToast hook is now solely defined in `hooks/useToast.ts`, so the duplicate definition is removed from this file.

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toastMessage, setToastMessage] = useState<string | null>(null);

  const showToast = useCallback((message: string) => {
    setToastMessage(message);
    setTimeout(() => {
      setToastMessage(null);
    }, 4000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toastMessage && (
        <div className="fixed top-20 right-5 bg-green-500 text-white py-2 px-4 rounded-lg shadow-lg z-50 animate-fade-in-out">
          {toastMessage}
        </div>
      )}
    </ToastContext.Provider>
  );
};